import { render, staticRenderFns } from "./coupon-review.vue?vue&type=template&id=b715e332&"
import script from "./coupon-review.vue?vue&type=script&lang=js&"
export * from "./coupon-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports